require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.deviceList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  var _default = {
    name: "DeviceList",
    data: function data() {
      return {
        time: '',
        dayText: '',
        phone: '',
        userList: [],
        showAll: false,
        currentOxygen: 0,
        name: '',
        chartDataArr: []
      };
    },
    created: function created() {
      var vm = this; // let name = '九洲合作社养鱼示范基地'
      // if (vm.$route.params.id == '498CFDA0AA8A2E9A') {
      //     name = '黄河合作社物联网大屏示范'
      // }
      // vm.name = name

      vm.pageNo = 1;
      vm.pageSize = 20;
      vm.selectedIndex = 0;
      vm.loadUserList();
      vm.refreshTime();
      setInterval(vm.refreshTime, 1000);

      window.onresize = function () {
        setTimeout(function () {
          vm.loadUserList();
        }, 1500);
      };
    },
    methods: {
      refreshTime: function refreshTime() {
        var vm = this;
        var t = new Date();
        var hours = t.getHours() > 9 ? t.getHours() : "0".concat(t.getHours());
        var min = t.getMinutes() > 9 ? t.getMinutes() : "0".concat(t.getMinutes());
        var seconds = t.getSeconds() > 9 ? t.getSeconds() : "0".concat(t.getSeconds());
        var month = t.getMonth() + 1 > 9 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1);
        var day = t.getDay();
        var date = t.getDate() > 9 ? t.getDate() : "0".concat(t.getDate());
        var weekDay = '星期一';

        switch (day) {
          case 2:
            weekDay = '星期二';
            break;

          case 3:
            weekDay = '星期三';
            break;

          case 4:
            weekDay = '星期四';
            break;

          case 5:
            weekDay = '星期五';
            break;

          case 6:
            weekDay = '星期六';
            break;

          case 7:
            weekDay = '星期日';
            break;

          default:
            break;
        }

        vm.time = "".concat(hours, ":").concat(min, ":").concat(seconds);
        vm.dayText = "".concat(month, "-").concat(date, "     ").concat(weekDay);
      },
      loadUserList: function loadUserList(pageNo, type) {
        var vm = this;
        var params = {
          // type: vm.$route.params.id,
          pageNo: Number(pageNo) > 0 ? pageNo : vm.pageNo,
          pageSize: vm.pageSize,
          encodeId: vm.$route.params.id
        };
        Number(pageNo) > 0 && (vm.pageNo = pageNo);
        type == 'remove' && (vm.phone = '');
        vm.phone && (params.params = vm.phone);
        vm.$http({
          type: "get",
          // url: `${vm.$config.base.ADMIN_URL}javaApi/iot/gov/userList`,
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/").concat(vm.phone ? 'iot/gov/screen/query' : 'iot/gov/screen'),
          params: params,
          except: true
        }).then(function (res) {
          if (!res.data) {
            vm.$message({
              type: 'warning',
              message: res.message || '服务器繁忙，请稍后~'
            });
            return;
          }

          vm.name = res.data.name;
          vm.pageNo == 1 && (res.data.userPage.records[0].selected = true);
          vm.userList = vm.pageNo == 1 ? res.data.userPage.records : vm.userList.concat(res.data.userPage.records);
          vm.showAll = res.data.userPage.records.length < vm.pageSize;
          vm.pageNo == 1 && vm.loadChartData();
        });
      },
      loadNextPage: function loadNextPage() {
        var vm = this;
        vm.pageNo = vm.pageNo + 1;
        vm.loadUserList();
      },
      search: function search() {
        var vm = this;
        vm.pageNo = 1;

        if (!(vm.phone && [8, 11].indexOf(vm.phone.length) > -1)) {
          vm.$message({
            type: 'warning',
            message: '请输入8位设备编码或11为手机号码'
          });
          return;
        }

        vm.loadUserList(1);
      },
      selectItem: function selectItem(index) {
        var vm = this;
        vm.userList.map(function (item, i) {
          item.selected = i == index;
        });
        vm.selectedIndex = index;
        vm.userList = [].concat(vm.userList);
        this.chartDataArr = [];
        vm.loadChartData();
      },
      handleCommand: function handleCommand(num) {
        this.chartDataArr["".concat(num).split('_')[1]].switchNumber = "".concat(num).split('_')[0];
        this.drawKzqChart("".concat(num).split('_')[1]);
      },
      loadChartData: function loadChartData() {
        var vm = this;
        var sItem = vm.userList[vm.selectedIndex];
        sItem.deviceList && sItem.deviceList.map(function (item, index) {
          if ([0, 1, 5, 10].indexOf(item.type) > -1) {
            vm.loadKZQData(item, index);
          }

          if ([3, 4, 6, 7, 9, 11, 13, 14].indexOf(item.type) > -1) {
            vm.loadRyData(item, index);
          }
        });
      },
      loadRyData: function loadRyData(item, index) {
        var vm = this;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/iot/gov/ry/curve"),
          params: {
            iotDeviceId: item.encodeId
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          } // vm.ryData = res.data


          res.data.poolName = item.poolName || '闲置中';
          res.data.type = 3;
          res.data.switchNumber = 1;
          vm.chartDataArr[index] = res.data;
          res.data && res.data.data && res.data.data.length && setTimeout(function () {
            vm.drawRyChart(index);
          }, 1000);
        });
      },
      loadKZQData: function loadKZQData(item, index) {
        var vm = this;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/iot/gov/kzq/data"),
          params: {
            iotDeviceId: item.encodeId
          },
          except: true
        }).then(function (res) {
          if (!res || !res.data) {
            return;
          }

          var _res$data = res.data,
              lastMonthQuantity = _res$data.lastMonthQuantity,
              currentMonthQuantity = _res$data.currentMonthQuantity;

          if (lastMonthQuantity > 0) {
            var unPower = currentMonthQuantity - lastMonthQuantity;
            unPower > 0 ? res.data.upPower = "".concat((unPower * 100 / lastMonthQuantity).toFixed(1), "%") : res.data.downPower = "".concat(((lastMonthQuantity - currentMonthQuantity) * 100 / lastMonthQuantity).toFixed(1), "%");
          } // res.data.electricConsumption.map((el, index) => {
          //     !el && (res.data.electricConsumption[index] = 0.1);
          // })


          var electricConsumption = res.data.electricConsumption;
          var maxPower = [].concat(electricConsumption).sort(function (a, b) {
            return b - a;
          })[0] || 1;
          res.data.powerWidth = [res.data.electricConsumption[0] * 100 / maxPower, res.data.electricConsumption[1] * 100 / maxPower, res.data.electricConsumption[2] * 100 / maxPower, res.data.electricConsumption[3] * 100 / maxPower];
          res.data.maxIndex = electricConsumption.indexOf(maxPower); // vm.kzqData = res.data

          res.data.poolName = item.poolName || '闲置中';
          res.data.type = 0;
          res.data.switchNumber = 1;
          vm.chartDataArr[index] = res.data;
          res.data.data && res.data.data.length && setTimeout(function () {
            vm.drawKzqChart(index);
          }, 1000);
        });
      },
      drawKzqChart: function drawKzqChart(index) {
        var vm = this;
        var date = [];
        var data = vm.chartDataArr[index] ? vm.chartDataArr[index].data : [];
        var power = [];

        if (!data.length) {
          return;
        }

        if (new Date(data[0].createAt * 1000).getTime() - vm.$time.getUnixTime() > 60 * 3 * 1000) {
          data.unshift({
            switch1Current: '-',
            switch2Current: '-',
            switch3Current: '-',
            switch4Current: '-',
            createAt: vm.$time.getUnixTime() / 1000
          });
        }

        if (new Date(data[data.length - 1].createAt * 1000).getTime() - vm.$time.getUnixTime() < 3600 * 23.9 * 1000) {
          data.push({
            switch1Current: '-',
            switch2Current: '-',
            switch3Current: '-',
            switch4Current: '-',
            createAt: vm.$time.getUnixTime() / 1000 + 24 * 3600 - 1
          });
        }

        data.map(function (item, index_) {
          var count = data[index_ + 1] && (data[index_ + 1].createAt - item.createAt) / 700;

          if (count > 1) {
            power.push(item["switch".concat(vm.chartDataArr[index].switchNumber, "Current")]);
            date.push(vm.$time.getHoursMin(item.createAt * 1000));

            for (var j = 1; j < count; j++) {
              power.push('-');
              date.push(vm.$time.getHoursMin(item.createAt * 1000 + 700 * j * 1000));
            }
          } else {
            power.push(item["switch".concat(vm.chartDataArr[index].switchNumber, "Current")]);
            date.push(vm.$time.getHoursMin(item.createAt * 1000));
          }
        });

        try {
          document.getElementById("kzq-chart-".concat(index)) && document.getElementById("kzq-chart-".concat(index)).setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById("kzq-chart-".concat(index)));
          myChart.setOption({
            // width: '370px',
            tooltip: {
              trigger: 'axis',
              position: function position(pt) {
                return [pt[0], '10%'];
              }
            },
            title: {
              left: 'center',
              text: ''
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: date,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '100%'],
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            series: [{
              name: '电流',
              type: 'line',
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(99, 236, 255, 0)'
              },
              areaStyle: {
                color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(99, 236, 255, 50)'
                }, {
                  offset: 1,
                  color: 'rgba(99, 236, 255, 0)'
                }])
              },
              data: power
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      drawRyChart: function drawRyChart(index) {
        var vm = this;
        var date = [];
        var data = vm.chartDataArr[index] ? vm.chartDataArr[index].data : [];
        var power = [];

        if (!data) {
          return;
        }

        data = data.sort(function (a, b) {
          return a.time - b.time;
        });
        data[data.length - 1].oxygen >= 0 && (vm.currentOxygen = data[data.length - 1].oxygen);

        if (new Date(data[0].time * 1000).getTime() - vm.$time.getUnixTime() > 60 * 3 * 1000) {
          data.unshift({
            oxygen: '-',
            time: vm.$time.getUnixTime() / 1000
          });
        }

        if (new Date(data[data.length - 1].time * 1000).getTime() - vm.$time.getUnixTime() < 3600 * 23.9 * 1000) {
          data.push({
            oxygen: '-',
            time: vm.$time.getUnixTime() / 1000 + 24 * 3600 - 1
          });
        }

        data.map(function (item, index) {
          var count = data[index + 1] && (data[index + 1].time - item.time) / 2400;

          if (count > 1) {
            power.push(item.oxygen || 0);
            date.push(vm.$time.getHoursMin(item.time * 1000));

            for (var j = 1; j < count; j++) {
              power.push('-');
              date.push(vm.$time.getHoursMin(item.time * 1000 + 1200 * j * 1000));
            }
          } else {
            power.push(item.oxygen || 0);
            date.push(vm.$time.getHoursMin(item.time * 1000));
          }
        });

        try {
          document.getElementById("ryy-chart-".concat(index)) && document.getElementById("ryy-chart-".concat(index)).setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById("ryy-chart-".concat(index)));
          myChart.setOption({
            tooltip: {
              trigger: 'axis',
              position: function position(pt) {
                return [pt[0], '10%'];
              }
            },
            title: {
              left: 'center',
              text: ''
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: date,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff'
                }
              }
            },
            yAxis: {
              type: 'value',
              boundaryGap: [0, '100%'],
              axisLabel: {
                textStyle: {
                  color: '#fff'
                }
              }
            },
            series: [{
              name: '溶氧',
              type: 'line',
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(99, 236, 255, 0)'
              },
              areaStyle: {
                color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#C56CFF'
                }, {
                  offset: 1,
                  color: '#8A3CFF'
                }])
              },
              data: power
            }]
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };
  _exports.default = _default;
});